import {ConfigProvider} from "antd";
import locale from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from "react-redux";
import {BrowserRouter} from "react-router-dom";
import '../common.css'
import {store} from "../config/store";
import reportWebVitals from '../reportWebVitals';

const render = (entry) => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
        <ConfigProvider locale={locale}>
            <Provider store={store}>
                <BrowserRouter>
                    {entry}
                </BrowserRouter>
            </Provider>
        </ConfigProvider>
    );
}

export default render

reportWebVitals();
